module.exports = __webpack_public_path__ + "static/bg-header-576-6b04ef6b804175c4de31e801aa314ad4.jpg";